<div class="main-container">
  <form [formGroup]="govtServersForm" novalidate>
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        @if (!serverId) {
          <span class="page-title">Add Government Servers</span>
        }
        @if (serverId) {
          <span class="page-title">View/Update Government Servers</span>
        }
      </div>
    </div>

    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Government Servers Details</h6>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <div class="form-section">
          <!-- State -->
          <div class="form-group">
            <label for="state" class="form-label">State</label>
            <mat-form-field appearance="outline">
              <mat-label>State</mat-label>
              <input
                placeholder="State Name"
                formControlName="state"
                matInput
                type="text"
                required
                [readonly]="govtServersUpdate && govtServersPermissionUpdate"
              />
              @if (
                govtServersForm.controls['state'].touched &&
                govtServersForm.controls['state'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    govtServersForm.controls['state'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- State Abbreviation -->
          <div class="form-group">
            <label for="stateAbbreviation" class="form-label"
              >State Abbreviation</label
            >
            <mat-form-field appearance="outline">
              <mat-label>State Abbreviation</mat-label>
              <input
                placeholder="State Abbreviation"
                formControlName="stateAbbreviation"
                matInput
                type="text"
                required
                [readonly]="govtServersUpdate && govtServersPermissionUpdate"
              />
              @if (
                govtServersForm.controls['stateAbbreviation'].touched &&
                govtServersForm.controls['stateAbbreviation'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    govtServersForm.controls['stateAbbreviation'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
              @if (
                govtServersForm.controls['stateAbbreviation'].touched &&
                govtServersForm.controls['stateAbbreviation'].errors?.pattern
              ) {
                <mat-error>
                  Please enter a valid State Abbreviation.
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- 1st SEO -->
          <div class="form-group">
            <label for="stateEnable" class="form-label">1st SEO</label>
            <mat-form-field appearance="outline">
              <mat-label>1st SEO</mat-label>
              <input
                placeholder="1st SEO Command"
                formControlName="stateEnable"
                matInput
                type="text"
              />
              @if (
                govtServersForm.controls['stateEnable'].touched &&
                govtServersForm.controls['stateEnable'].errors?.pattern
              ) {
                <mat-error> Please enter a valid 1st SEO. </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Govt. IP1 -->
          <div class="form-group">
            <label for="govtIp1" class="form-label">Govt. IP1</label>
            <mat-form-field appearance="outline">
              <mat-label>Govt. IP1</mat-label>
              <input
                placeholder="Govt. IP1"
                formControlName="govtIp1"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>
          <!-- Port1 -->
          <div class="form-group">
            <label for="port1" class="form-label">Port1</label>
            <mat-form-field appearance="outline">
              <mat-label>Port1</mat-label>
              <input
                placeholder="Port1"
                formControlName="port1"
                matInput
                type="text"
              />
              @if (
                govtServersForm.controls['port1'].touched &&
                govtServersForm.controls['port1'].errors?.portValidation
              ) {
                <mat-error>
                  {{ govtServersForm.controls['port1'].errors?.portValidation }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Govt. IP2 -->
          <div class="form-group">
            <label for="govtIp2" class="form-label">Govt. IP2</label>
            <mat-form-field appearance="outline">
              <mat-label>Govt. IP2</mat-label>
              <input
                placeholder="Govt. IP2"
                formControlName="govtIp2"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>
          <!-- Port2 -->
          <div class="form-group">
            <label for="port2" class="form-label">Port2</label>
            <mat-form-field appearance="outline">
              <mat-label>Port2</mat-label>
              <input
                placeholder="Port2"
                formControlName="port2"
                matInput
                type="text"
              />
              @if (
                govtServersForm.controls['port2'].touched &&
                govtServersForm.controls['port2'].errors?.portValidation
              ) {
                <mat-error>
                  {{ govtServersForm.controls['port2'].errors?.portValidation }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- 2nd SEO -->
          <div class="form-group">
            <label for="secondaryStateEnable" class="form-label">2nd SEO</label>
            <mat-form-field appearance="outline">
              <mat-label>2nd SEO</mat-label>
              <input
                placeholder="2nd SEO Command"
                formControlName="secondaryStateEnable"
                matInput
                type="text"
              />
              @if (
                govtServersForm.controls['secondaryStateEnable'].touched &&
                govtServersForm.controls['secondaryStateEnable'].errors?.pattern
              ) {
                <mat-error> Please enter a valid 2nd SEO. </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Govt. IP3 -->
          <div class="form-group">
            <label for="govtIp3" class="form-label">Govt. IP3</label>
            <mat-form-field appearance="outline">
              <mat-label>Govt. IP3</mat-label>
              <input
                placeholder="Govt. IP3"
                formControlName="govtIp3"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>
          <!-- Port3 -->
          <div class="form-group">
            <label for="port3" class="form-label">Port3</label>
            <mat-form-field appearance="outline">
              <mat-label>Port3</mat-label>
              <input
                placeholder="Port3"
                formControlName="port3"
                matInput
                type="text"
              />
              @if (
                govtServersForm.controls['port3'].touched &&
                govtServersForm.controls['port3'].errors?.portValidation
              ) {
                <mat-error>
                  {{
                    govtServersForm.controls['port3 '].errors?.portValidation
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Govt. IP4 -->
          <div class="form-group">
            <label for="govtIp4" class="form-label">Govt. IP4</label>
            <mat-form-field appearance="outline">
              <mat-label>Govt. IP4</mat-label>
              <input
                placeholder="Govt. IP4"
                formControlName="govtIp4"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>
          <!-- Port4 -->
          <div class="form-group">
            <label for="port4" class="form-label">Port4</label>
            <mat-form-field appearance="outline">
              <mat-label>Port4</mat-label>
              <input
                placeholder="Port4"
                formControlName="port4"
                matInput
                type="text"
              />
              @if (
                govtServersForm.controls['port4'].touched &&
                govtServersForm.controls['port4'].errors?.portValidation
              ) {
                <mat-error>
                  {{ govtServersForm.controls['port4'].errors?.portValidation }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="component-separator"></div>

      <div class="component-footer">
        <div class="button-group">
          @if (govtServersCreate && govtServersPermissionCreate) {
            <button
              type="button"
              class="submit-button"
              (click)="submitGovtServers()"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          }
          @if (govtServersUpdate && govtServersPermissionUpdate) {
            <button
              type="button"
              class="edit-button"
              (click)="updateGovtServers()"
            >
              Update <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>

    @if (serverId) {
      <!-- Firmware Section -->
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">Firmware List</h6>
          <div class="component-actions">
            @if (govtServersPermissionCreate) {
              <button
                class="primary-button"
                type="button"
                (click)="openFirmwareModal()"
              >
                Add Firmware
                <mat-icon class="btn-icon">add</mat-icon>
              </button>
            }
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Firmware Version</th>
                <th>File Name</th>
                <th>Firmware Description</th>
                <th>Expected Firmware Version</th>
                <th>Created By</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>

            @if (firmwareList.length > 0) {
              <tbody>
                @for (
                  row of firmwareList
                    | paginate
                      : {
                          id: 'batchPaginate',
                          itemsPerPage: size,
                          currentPage: page,
                          totalItems: totalLength,
                        };
                  track row;
                  let i = $index
                ) {
                  <tr>
                    <td>{{ row.firmwareVersion }}</td>
                    <td>{{ row.fileName }}</td>
                    <td>{{ row.description || '--' }}</td>
                    <td>{{ row.expectedFirmwareVersion || '--' }}</td>
                    <td>{{ row.createdBy?.fullName || '--' }}</td>
                    <td>
                      {{
                        row.createdAt
                          ? (row.createdAt | date: 'dd MMM yyyy | hh:mm:ss a')
                          : '--'
                      }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        @if (govtServersPermissionDelete) {
                          <button
                            type="button"
                            class="primary-button delete-button"
                            (click)="deleteFirmware(row._id)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                        @if (
                          govtServersPermissionUpdate &&
                          !row.expectedFirmwareVersion
                        ) {
                          <button
                            type="button"
                            class="primary-button edit-button"
                            (click)="
                              updateFirmwareExpectedFirmwareVersionData(row._id)
                            "
                          >
                            <mat-icon class="btn-icon">edit</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            } @else {
              <tbody>
                <tr>
                  <td colspan="6">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          @if (totalLength !== 0) {
            <app-common-component-pagination
              [totalItems]="totalLength"
              [pageSize]="size"
              [currentPage]="page"
              [totalPages]="totalLength"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }
  </form>
  <!-- Firmware Modal -->
  <div class="custom-container">
    <div class="custom-modal custom-modal-s" id="firmwareModal">
      <div class="custom-modal-dialog">
        <div class="custom-modal-content">
          <!-- Header -->
          <div class="custom-modal-header">
            <h4 class="custom-modal-title">Add Firmware</h4>
            <button class="custom-close-btn" (click)="closeModal()">
              &times;
            </button>
          </div>

          <!-- Body -->
          <form [formGroup]="firmwareForm">
            <div class="custom-modal-body">
              <div class="component-container">
                <div class="component-body">
                  <div class="form-section">
                    <!-- Firmware Version -->
                    <div class="form-group">
                      <mat-form-field appearance="outline">
                        <mat-label>Firmware Version</mat-label>
                        <input
                          type="text"
                          placeholder="Firmware Version"
                          aria-label="Firmware Version"
                          formControlName="firmwareVersion"
                          matInput
                          required
                        />
                        @if (
                          firmwareForm.controls['firmwareVersion'].touched &&
                          firmwareForm.controls['firmwareVersion'].errors
                            ?.requiredAndNoEmptySpaces
                        ) {
                          <mat-error>
                            {{
                              firmwareForm.controls['firmwareVersion'].errors
                                ?.requiredAndNoEmptySpaces
                            }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <!-- File -->
                    <div class="form-group">
                      <mat-form-field
                        class="file-upload-container"
                        appearance="outline"
                      >
                        <mat-label>Upload File</mat-label>

                        <!-- Display File Name or Placeholder -->
                        <input
                          matInput
                          type="text"
                          formControlName="fileName"
                          [value]="firmwareForm.controls['fileName'].value"
                          required
                        />

                        <!-- Hidden File Input -->
                        <input
                          type="file"
                          accept=".bin"
                          aria-label="File"
                          class="d-none"
                          (change)="file_upload($event)"
                          #fileInput
                        />

                        <!-- Custom Upload Button -->
                        <button
                          mat-button
                          class="upload-btn"
                          (click)="fileInput.click()"
                          type="button"
                        >
                          <mat-icon>attach_file</mat-icon>
                        </button>

                        <!-- Error Message -->
                        @if (
                          firmwareForm.controls['fileName'].touched &&
                          firmwareForm.controls['fileName'].errors
                            ?.requiredAndNoEmptySpaces
                        ) {
                          <mat-error> This field is Mandatory. </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <!-- Description -->
                    <div class="form-group">
                      <mat-form-field appearance="outline">
                        <mat-label>File Description</mat-label>
                        <input
                          type="text"
                          placeholder="Firmware Description"
                          matInput
                          formControlName="description"
                        />
                      </mat-form-field>
                    </div>
                    <!-- Expected Firmware Version -->
                    <div class="form-group">
                      <mat-form-field appearance="outline">
                        <mat-label>Expected Firmware Version</mat-label>
                        <input
                          matInput
                          formControlName="expectedFirmwareVersion"
                          required
                        />
                        @if (
                          firmwareForm.controls['expectedFirmwareVersion']
                            .touched &&
                          firmwareForm.controls['expectedFirmwareVersion']
                            .errors?.requiredAndNoEmptySpaces
                        ) {
                          <mat-error>
                            {{
                              firmwareForm.controls['expectedFirmwareVersion']
                                .errors?.requiredAndNoEmptySpaces
                            }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Separator between Body and Footer -->
              <div class="component-separator"></div>

              <div class="component-footer">
                <div class="button-group">
                  <button
                    type="button"
                    class="submit-button"
                    (click)="addFirmware()"
                  >
                    Add Firmware
                    <mat-icon class="btn-icon">check_circle</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
